import { render } from "./GameCloseConfirm.vue?vue&type=template&id=dd20e1b2&ts=true"
import script from "./GameCloseConfirm.vue?vue&type=script&lang=ts"
export * from "./GameCloseConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__